// 格式化工具函数

export function yuan(v, decimals = 2) {
  if (v == null || isNaN(v)) return '0.00';
  return Number(v).toFixed(decimals);
}

export function percent(v, decimals = 2) {
  if (v == null || isNaN(v)) return '0.00';
  return (Number(v) * 100).toFixed(decimals);
}

export function formatMargin(margin) {
  const pct = (margin * 100).toFixed(3); // 毛利率 3 位小数百分比
  const color = margin >= 0.15 ? '#CF1322' : margin >= 0.08 ? '#EF9F27' : '#3F8600';
  return { text: `${pct}%`, color };
}

// 克数展示：>=1000g 显示 kg，否则显示 g
export function fmtWeight(g) {
  const v = Number(g);
  if (v == null || isNaN(v) || v <= 0) return '-';
  if (v >= 1000) return `${(v / 1000).toFixed(2)}kg`;
  return `${v}g`;
}

// 运费模板行计算：0-1KG/1-2KG/2-3KG 固定运费，3KG以上 = 商品重量×续重费 + 首重
// row: { fee_0_1, fee_1_2, fee_2_3, fee_3_first, fee_3_add }；某档位未填返回 null
export function calcTemplateRowFreight(row, weight) {
  const w = Number(weight);
  if (!row || w == null || isNaN(w) || w <= 0) return null;
  let fee = null;
  if (w <= 1) fee = row.fee_0_1 != null ? Number(row.fee_0_1) : null;
  else if (w <= 2) fee = row.fee_1_2 != null ? Number(row.fee_1_2) : null;
  else if (w <= 3) fee = row.fee_2_3 != null ? Number(row.fee_2_3) : null;
  else {
    const first = row.fee_3_first != null ? Number(row.fee_3_first) : null;
    if (first == null) return null;
    const add = row.fee_3_add != null ? Number(row.fee_3_add) : 0;
    fee = first + w * add; // 3KG以上：商品重量 × 续重费 + 首重
  }
  return fee == null ? null : Math.round(fee * 100) / 100;
}

// 省份/城市名归一化：去掉 省/市/自治区/壮族/回族/维吾尔/特别行政区 后缀
export function normalizeRegionName(name) {
  if (!name) return '';
  return String(name)
    .replace(/特别行政区$/, '').replace(/壮族自治区$/, '').replace(/回族自治区$/, '')
    .replace(/维吾尔自治区$/, '').replace(/自治区$/, '').replace(/省$/, '')
    .replace(/市$/, '').replace(/\s+/g, '').trim();
}

// 模板行按区域+省份匹配：1) 省份命中的城市行；2) city 留空的通用行；3) 无 → null（回退商品兜底）
export function matchTemplateRow(template, region, province) {
  if (!Array.isArray(template) || !region) return null;
  const rows = template.filter(r => r && r.region === region);
  if (!rows.length) return null;
  const provNorm = normalizeRegionName(province);
  if (provNorm) {
    const byCity = rows.find(r => r.city && normalizeRegionName(r.city) === provNorm);
    if (byCity) return byCity;
  }
  const generic = rows.find(r => !r.city);
  if (generic) return generic;
  return null;
}

export const ZONE_META = [
  { key: '一区', field: 'shipping_fee_zone1', color: 'green', bg: '#f6ffed' },
  { key: '二区', field: 'shipping_fee_zone2', color: 'blue', bg: '#e6f4ff' },
  { key: '三区', field: 'shipping_fee_zone3', color: 'orange', bg: '#fff7e6' },
  { key: '四区', field: 'shipping_fee_zone4', color: 'purple', bg: '#f9f0ff' },
];

// 区域对应 antd Tag 颜色
export function zoneTagColor(zone) {
  const m = { '一区': 'green', '二区': 'blue', '三区': 'orange', '四区': 'purple' };
  return m[zone] || 'default';
}

// 区域对应图表十六进制颜色（与品牌色板一致）
export function zoneHexColor(zone) {
  const m = { '一区': '#3F8600', '二区': '#D85A30', '三区': '#EF9F27', '四区': '#D4537E' };
  return m[zone] || '#8C8178';
}
